import {
  BadgeCheck,
  Bath,
  Building2,
  Check,
  CircleDollarSign,
  ClipboardList,
  Clock3,
  DoorOpen,
  DraftingCompass,
  Facebook,
  Gem,
  Grid2X2,
  Hammer,
  Handshake,
  House,
  Image,
  Instagram,
  Layers,
  LoaderCircle,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  PanelsTopLeft,
  Palette,
  PanelTop,
  Phone,
  Plus,
  Quote,
  Rocket,
  Ruler,
  Send,
  Settings,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Square,
  Star,
  Target,
  Truck,
  UsersRound,
  Wrench,
  X,
  type LucideProps,
} from 'lucide-react';

const iconByName = {
  BadgeCheck,
  Bath,
  Building2,
  Check,
  CircleDollarSign,
  ClipboardList,
  Clock3,
  DoorOpen,
  DraftingCompass,
  Facebook,
  Gem,
  Grid2X2,
  Hammer,
  Handshake,
  House,
  Image,
  Instagram,
  Layers,
  LoaderCircle,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  PanelsTopLeft,
  Palette,
  PanelTop,
  Phone,
  Plus,
  Quote,
  Rocket,
  Ruler,
  Send,
  Settings,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Square,
  Star,
  Target,
  Truck,
  UsersRound,
  Wrench,
  X,
};

export type IconName = keyof typeof iconByName;

type IconProps = LucideProps & { name: IconName };

export function Icon({ name, size = 20, strokeWidth = 2, ...props }: IconProps) {
  const IconComponent = iconByName[name];
  return <IconComponent aria-hidden="true" focusable="false" size={size} strokeWidth={strokeWidth} {...props} />;
}
